<template>


  <div id="app">

     
    <calendar>

    </calendar> 

  </div>
</template>

<script>
import Calendar from './components/calendar/Calendar'



export default {
  name: 'app',
  components: {
    Calendar
  }
}
</script>



<style lang="less">
	
	@import './assets/less/main.less'; 

</style>


// WEBPACK FOOTER //
// App.vue?83e93872